"use client";
import { useEffect, useState } from "react";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import Link from "next/link";

const CarouselComp = ({ images }: { images: any[] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full mx-auto bg-green overflow-hidden">
      <div className="relative w-full h-[90vh]">
        {images.map((image, index) => (
          <Link
            key={`${image.id}-${index}`}
            href={image.href}
            className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
              index === currentIndex
                ? "opacity-100 blur-0 scale-100 pointer-events-auto z-10"
                : "opacity-0 blur-md scale-110 pointer-events-none"
            }`}
          >
            <img
              src={image.imageSrc}
              alt={image.name}
              className="w-full h-full object-cover"
            />
            <p className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 text-white text-lg sm:text-2xl lg:text-5xl font-bold">
              {image.name}
            </p>
          </Link>
        ))}
      </div>

      {images.length > 1 && (
        <button
          onClick={handlePrev}
          className="absolute z-20 top-1/2 left-4 transform -translate-y-1/2 bg-[#d9eae3] bg-opacity-60 text-green p-2 rounded-full shadow-lg hover:bg-opacity-100 focus:outline-none"
        >
          <ArrowLeftIcon className="size-6" />
        </button>
      )}

      {images.length > 1 && (
        <button
          onClick={handleNext}
          className="absolute z-20 top-1/2 right-4 transform -translate-y-1/2 bg-[#d9eae3] bg-opacity-60 text-green p-2 rounded-full shadow-lg hover:bg-opacity-100 focus:outline-none"
        >
          <ArrowRightIcon className="size-6" />
        </button>
      )}
    </div>
  );
};

export default CarouselComp;
